import {
    isLocalHost,
    getHostName,
} from '../../utils/environmentUtil/environmentUtil';

export const getModuleName = (optionalName: string) => {
    if (isLocalHost()) {
        return {
            module: optionalName,
        };
    }

    const domainMatch = getHostName();
    if (!domainMatch) {
        throw new Error(
            `Domain did not match. Domain: "${window.location.hostname}"`,
        );
    }
    return {
        module: domainMatch[0],
    };
};

const loadModule = async (optionalName: string) => {
    const moduleName = getModuleName(optionalName).module;
    return import(`../../domains/${moduleName}`);
};

export default loadModule;
